// extracted by mini-css-extract-plugin
export default {"manageTeamPage":"ManageTeamPage_manageTeamPage__cEnfM"};